export default [
  {
    path: "/businesses/:businessId/business",
    props: true,
    component: () => import("@/views/business/settings/BusinessSettingsView.vue"),
    meta: {
      authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/profile",
    props: true,
    component: () => import("@/views/business/profile/BusinessProfile.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/settings",
    props: true,
    component: () => import("@/views/business/settings/BusinessRedeemSettings.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/activitytypes",
    props: true,
    component: () => import("@/views/business/activitytype/BusinessActivityTypes.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/roles",
    props: true,
    component: () => import("@/views/business/roles/BusinessRolesView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/transition-settings",
    props: true,
    component: () => import("@/views/business/transitionsettings/BusinessTransitionSettings.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/locations",
    props: true,
    component: () => import("@/views/business/locations/BusinessLocations.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
    },
  },
  {
    path: "/businesses/:businessId/business/program-price-change-request",
    props: true,
    component: () => import("@/views/business/program-price-chaneges/BusinessProgramPriceChanges.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/users",
    props: true,
    component: () => import("@/views/business/business-users/BusinessUsersView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "users",
        props: true,
        component: () => import("@/views/business/business-users/BusinessUsersView.vue"),
        meta: {
          component: "BusinessUsers",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "invites",
        props: true,
        component: () => import("@/views/business/business-users/BusinessUsersView.vue"),
        meta: {
          component: "BusinessUserInvites",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/businesses/:businessId/business/brand",
    props: true,
    component: () => import("@/views/business/brand/BusinessBrand.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/subscription",
    props: true,
    component: () => import("@/views/business/business-subscription/BusinessSubscription.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "details",
        props: true,
        component: () => import("@/views/business/business-subscription/BusinessSubscription.vue"),
        meta: {
          component: "SubscriptionCard",
          authentication: { required: true },
          authorization: { roles: ["business_administrator"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "payments",
        props: true,
        component: () => import("@/views/business/business-subscription/BusinessSubscription.vue"),
        meta: {
          component: "PaymentHistory",
          authentication: { required: true },
          authorization: { roles: ["business_administrator"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/businesses/:businessId/business/merchant",
    props: true,
    component: () => import("@/views/business/stripe-connection/BusinessMerchantProcessing.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/cardreaders",
    props: true,
    component: () => import("@/views/business/card-readers/BusinessCardReaders.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/taxrates",
    props: true,
    component: () => import("@/views/business/tax-rates/BusinessTaxRates.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/members/",
    props: true,
    component: () => import("@/views/business/member-search/BusinessMembersView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/prescriptions/",
    props: true,
    component: () => import("@/views/business/prescriptions/BusinessPrescriptionsView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/newprescription/",
    redirect: (to) => `/businesses/${to.params.businessId}/prescriptions`,
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business-todo/",
    props: true,
    component: () => import("@/views/business/todo/business-todo/BusinessTodoView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "unassigned",
        props: true,
        component: () => import("@/views/business/todo/business-todo/BusinessTodoView.vue"),
        meta: {
          component: "UnassignedTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "assigned",
        props: true,
        component: () => import("@/views/business/todo/business-todo/BusinessTodoView.vue"),
        meta: {
          component: "AssignedTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "completed",
        props: true,
        component: () => import("@/views/business/todo/business-todo/BusinessTodoView.vue"),
        meta: {
          component: "CompletedTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "order-in-progress",
        props: true,
        component: () => import("@/views/business/todo/business-todo/BusinessTodoView.vue"),
        meta: {
          component: "OrderInProgressTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/businesses/:businessId/location-todo/",
    props: true,
    component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "due-today",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "DueTodayTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "past-due",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "PastDueTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "follow-up",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "FollowUpTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "all",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "AllTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "completed",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "CompletedTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "completed-by-me",
        props: true,
        component: () => import("@/views/business/todo/location-todo/LocationTodoView.vue"),
        meta: {
          component: "CompletedByMeTodoView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/businesses/:businessId/trainings/mytraining",
    props: true,
    component: () => import("@/views/business/training/BusinessTrainingsView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/members/:userId/",
    props: true,
    component: () => import("@/views/business/member/BusinessMemberView"),
    children: [
      {
        path: "personal-info",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberInfo",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "credits",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberCredits",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "prescriptions",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberPrescriptions",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "plans",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberPlans",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "paymentmethod",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberPaymentMethod",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "history",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberHistory",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "invites",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberInvites",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "documents",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberDocuments",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "business-todo",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "BusinessMemberTodo",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "location-todo",
        props: true,
        component: () => import("@/views/business/member/BusinessMemberView"),
        meta: {
          component: "LocationMemberTodo",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "order-tracking",
        props: true,
        component: () => import("@/views/business/member/components/BusinessMemberTrackingList"),
        meta: {
          component: "BusinessMemberTrackingList",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
      {
        path: "order-history",
        props: true,
        component: () => import("@/views/business/member/components/BusinessMemberShippedHistoryList"),
        meta: {
          component: "BusinessMemberShippedHistoryList",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: false,
        },
      },
    ],
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/plans/",
    redirect: (to) => `/businesses/${to.params.businessId}/offerings/plans`,
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/offerings/",
    redirect: (to) => `/businesses/${to.params.businessId}/offerings/plans`,
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/offerings/",
    props: true,
    component: () => import("@/views/business/BusinessOfferingsView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "plans",
        props: true,
        component: () => import("@/views/business/business-plans/BusinessPlans.vue"),
        meta: {
          component: "BusinessPlans",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "products",
        props: true,
        component: () => import("@/views/business/business-item-categories/BusinessItemCategories.vue"),
        meta: {
          component: "BusinessItemCategories",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "programs",
        props: true,
        component: () => import("@/views/business/business-programs/BusinessPrograms.vue"),
        meta: {
          component: "BusinessPrograms",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "medications",
        props: true,
        component: () => import("@/views/business/business-medications/BusinessMedications.vue"),
        meta: {
          component: "BusinessMedications",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "rx/items",
        props: true,
        component: () => import("@/views/business/business-rx-items/BusinessRxItems.vue"),
        meta: {
          component: "BusinessRxItems",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "programs/msrp",
        props: true,
        component: () => import("@/views/business/business-programs-msrp/BusinessProgramsMsrp.vue"),
        meta: {
          component: "BusinessProgramsMsrp",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
    ],
  },
  {
    name: "activity-schedule",
    path: "/businesses/:businessId/plans/:businessPlanId/activity-schedule/:businessPlanName",
    props: true,
    component: () => import("@/views/business/business-plans/BusinessPlanActivitySchedule.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/reports",
    props: true,
    component: () => import("@/views/business/reports/BusinessReportsView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      showNavShadow: true,
    },
    children: [
      {
        path: "revenue",
        props: true,
        component: () => import("@/views/business/reports/revenue/BusinessRevenueReport.vue"),
        meta: {
          component: "BusinessRevenueReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "charges",
        props: true,
        component: () => import("@/views/business/reports/charges/BusinessMemberChargesReport.vue"),
        meta: {
          component: "BusinessMemberChargesReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "prescriptions",
        props: true,
        component: () => import("@/views/business/reports/prescriptions/BusinessPrescriptionsReport.vue"),
        meta: {
          component: "BusinessPrescriptionsReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "medication-transition",
        props: true,
        component: () => import("@/views/business/reports/medication-transition/BusinessMedicationTransitionReport.vue"),
        meta: {
          component: "BusinessMedicationTransitionReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "mass-clarification",
        props: true,
        component: () => import("@/views/business/reports/mass-clarification/BusinessMassClarificationReport.vue"),
        meta: {
          component: "BusinessMassClarificationReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "plans",
        props: true,
        component: () => import("@/views/business/reports/plans/MemberPlansReport.vue"),
        meta: {
          component: "MemberPlansReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "credits",
        props: true,
        component: () => import("@/views/business/reports/credits/BusinessCreditsReport.vue"),
        meta: {
          component: "BusinessCreditsReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "tax",
        props: true,
        component: () => import("@/views/business/reports/tax/BusinessTaxReport.vue"),
        meta: {
          component: "BusinessTaxReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "tip",
        props: true,
        component: () => import("@/views/business/reports/tips/BusinessTipReport.vue"),
        meta: {
          component: "BusinessTipReport",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
      {
        path: "zeroes",
        props: true,
        component: () => import("@/views/business/reports/zeroes/BusinessZeroesReportView.vue"),
        meta: {
          component: "BusinessZeroesReportView",
          authentication: { required: true },
          authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
          useNewContainer: true,
          showNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/businesses/:businessId/member-web-signup",
    props: true,
    component: () => import("@/views/business/business-member-signup/web-signup/BusinessMemberWebSignupView.vue"),
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/member-web-signup/success",
    props: true,
    component: () => import("@/views/business/business-member-signup/SignupSuccessView.vue"),
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },

  {
    path: "/businesses/:businessId/locations/:businessLocationId/member-location-web-signup",
    props: true,
    component: () => import("@/views/business/business-member-signup/location-signup/MemberLocationWebSignupView.vue"),
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/stripeconnect",
    component: () => import("@/views/business/stripe-connection/StripeConnectResponse.vue"),
    meta: {
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/user-invites/accept",
    props: true,
    component: () => import("@/views/business/business-users/BusinessUsersInviteAcceptView.vue"),
    meta: {
      authentication: { required: true, redirectMessage: "Please sign-in to Predictile to accept your business invite." },
      hideNav: true,
    },
  },
  {
    path: "/businesses/:businessId/dashboard",
    alias: "/businesses/:businessId/home",
    props: true,
    component: () => import("@/views/business/dashboard/BusinessDashboardView"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/support",
    props: true,
    component: () => import("@/views/business/support/BusinessSupportView"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/disputes",
    props: true,
    component: () => import("@/views/business/dispute/BusinessDisputes"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator"] },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/business/pharmacy",
    props: true,
    component: () => import("@/views/business/pharmacy/BusinessPharmacyView.vue"),
    meta: {
      component: "BusinessPharmacyView",
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/order/:orderId",
    props: true,
    component: () => import("@/views/business/order/BusinessOrderView.vue"),
    meta: {
      component: "BusinessOrderView",
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
  {
    path: "/businesses/:businessId/location/:businessLocationId/vendor-price-list",
    props: true,
    component: () => import("@/views/business/locations/components/VendorPriceListPdf.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management", "business_operations"] },
      useNewContainer: true,
    },
  },
  {
    path: "/businesses/:businessId/resolve-patient-tracking-issues",
    props: true,
    component: () => import("@/views/business/tools/ResolvePatientTrackingIssuesView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["business_administrator", "business_management,"] },
      useNewContainer: true,
      showNavShadow: true,
    },
  },
];
